// export.ts — CSV export of the practice history (all local; nothing leaves the device).

import type { Session } from "./store";
import { EXAM_LABELS, MODE_LABELS, bandRange } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Full CSV: Date, Exam, Mode, Topic, Turns, Answered, Estimated band range, Repeat avg. */
export function sessionsCsv(sessions: Session[]): string {
  return csv(
    ["Date", "Exam", "Mode", "Topic", "Turns", "Answered", "Estimated band range", "Listen & Repeat avg"],
    sessions.map((s) => [
      s.created_at.slice(0, 10),
      EXAM_LABELS[s.exam] ?? s.exam,
      MODE_LABELS[s.mode] ?? s.mode,
      s.topic,
      s.turn_count,
      s.answered_count,
      bandRange(s.band_low, s.band_high),
      s.avg_score != null ? `${Math.round(s.avg_score)}%` : "",
    ]),
  );
}

export function buildExport(sessions: Session[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: sessionsCsv(sessions), filename: `speaking-coach-${stamp}.csv` };
}
